<template>
  <div id="app">
    <capitalc-header/>
    <!-- <transition enter-active-class="fadeInUp"> -->
      <router-view/>
    <!-- </transition> -->
  </div>
</template>

<script>
import CapitalcHeader from '@/components/header/CapitalCHeader'
export default {
  components:{
    CapitalcHeader
  }
}
</script>